// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const Container = styled.div`
  // @media screen and (max-width: 1250px) {
  //   padding: 30px 30px 0px 30px;
  //   margin: 0 auto;
  // }
  // @media screen and (min-width: 1250px) {
  //   padding: 60px 80px 0px 80px;
  // }
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

export const Title = styled.text`
  font-size: 20px;
  font-weight: bold;
  color: ${COLORS.terraCotta};
  font-family: ${FONTS.montserrat};
  margin-left: 50px;
`;

export const Bar = styled.div`
  padding: 1px;
  background-color: ${COLORS.backgroundColor};
  margin: 10px 0 60px 0;
`;

export const NotificationBar = styled.div`
  padding: 1px;
  background-color: ${COLORS.backgroundColor};
  width: 400px;
  margin: 10px 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 70%;
`;
export const SendNotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 767px;
  background-color: #F5F5F5;
  margin-right: 10px;
  border-radius: 20px;
  padding: 25px 0 40px 0;
`;

export const TitleInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  margin-bottom: 30px;
`;

export const SendTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
`;

export const InputAtomContainer = styled.div(
  ({ width }) => css`
    width: ${width ? width : "300px"};
    @media screen and (min-width: 1451px) {
      margin-right: 80px;
    }
    @media screen and (max-width: 1450px) {
      margin-right: 30px;
    }
  `
);

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;
`;
export const BodyTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
`;

export const ButtonContainer = styled.div`
  margin: 0 auto;
`;
export const NotificationsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 860px;
  max-width: 600px;
  height: 767px;
  background-color: #F5F5F5;
  border-radius: 20px;
  padding: 25px 0;
`;

export const NotificationsListTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
`;

export const NotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 85%;
  padding-left: 30px;
  padding-right: 100px;
  margin-right: 15px;
  color: blue;
  overflow: hidden;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.cornflowerBlue} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  height: 110px;
`;

export const NotificationTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
`;

export const NotificationBodyText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.secondaryBlack};
  font-family: ${FONTS.montserrat};
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;
export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
`;

export const NotificationDate = styled.text`
  font-size: 12px;
  color: ${COLORS.primaryGray};
  font-family: ${FONTS.montserrat};
  margin-left: 5px;
`;

export const NotificationDateContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ClockIconImage = styled.img``;
